import { MutationOptions, gql } from '@apollo/client';
import {
  ActivatePlanFromCheckoutMutation,
  ActivatePlanFromCheckoutMutationVariables,
} from '../../graphql/types';
import { client } from '../../lib/apollo';
import { getAttributionMetadata } from '../../lib/attribution';

// Same optional attribution arguments as buyProducts. Values come from the
// attribution cookie and URL, not from a tt1 Stripe client_reference_id.
// api-v2 must accept these arguments before this operation is released.
const ACTIVATE_PLAN_FROM_CHECKOUT = gql`
  mutation ActivatePlanFromCheckout(
    $checkoutSessionId: String!
    $attributionSource: String
    $attributionMedium: String
    $attributionCampaign: String
    $gclid: String
    $gbraid: String
    $wbraid: String
    $fbclid: String
    $marketingAnonymousId: String
  ) {
    activatePlanFromCheckout(
      checkoutSessionId: $checkoutSessionId
      attributionSource: $attributionSource
      attributionMedium: $attributionMedium
      attributionCampaign: $attributionCampaign
      gclid: $gclid
      gbraid: $gbraid
      wbraid: $wbraid
      fbclid: $fbclid
      marketingAnonymousId: $marketingAnonymousId
    ) {
      plan
      year
      price
    }
  }
`;

export function buildActivatePlanFromCheckoutVariables(
  checkoutSessionId: string,
): ActivatePlanFromCheckoutMutationVariables {
  return {
    checkoutSessionId,
    ...getAttributionMetadata(),
  };
}

export const activatePlanFromCheckout = async (
  variables: MutationOptions<
    ActivatePlanFromCheckoutMutation,
    ActivatePlanFromCheckoutMutationVariables
  >['variables'],
) =>
  client.mutate<ActivatePlanFromCheckoutMutation, ActivatePlanFromCheckoutMutationVariables>({
    mutation: ACTIVATE_PLAN_FROM_CHECKOUT,
    variables,
  });
